<template>
  <v-sheet class="d-flex align-center px-3" width="100%" height="100%" >
    <v-sheet
      :min-width="25"
      :style="{ color: alert.color }"
      class="d-flex justify-center align-center mr-2"
    >
      <c360-icon :icon="alert.icon" :size="25" />
    </v-sheet>
    <p class="alert-text font-weight-bold mb-0" :style="{ color: alert.color }">{{ alert.title }}</p>
    <p class="alert-text font-weight-bold mb-0 mx-1" :style="{ color: alert.color }">·</p>
    <p class="alert-text c360-text-body-xs mb-0">{{ alert.message }}</p>
    <v-spacer />
    <v-sheet v-if="alert.dismissible" class="d-flex justify-center align-center">
      <v-btn icon @click="$emit('dismiss')">
        <c360-icon icon="Close_SM" />
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import { C360Icon } from '../../Icon';

  export default {
    name: 'C360Alert',

    components: {
      C360Icon,
    },

    props: {
      /**
       * @type {import('../interfaces').Alert}
       */
      alert: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped>
  .alert-text {
    font-size: 14px;
  }
</style>